<template>
  <div class="blockchain">
    <Header />
    <FirmwareUpgrade />
    <!-- <Footer /> -->
  </div>
</template>

<script>
import Footer from '../components/common/Footer.vue'
import Header from '../components/common/Header.vue'
import FirmwareUpgrade from '../components/firmwareUpgrade/FirmwareUpgrade.vue'
import { setMode } from "../utils";
export default {
  components: { Header, FirmwareUpgrade, Footer },
  created() {
    this.$store.commit('setDark', false);
    setMode(false);
  },
}
</script>
<style lang="scss" scoped>
.blockchain {
  .content {
    max-width: 11rem;
  }
}
</style>
